export default __webpack_public_path__ + "static/media/ms-dynamic-locator.9e47413b.svg";